<template>
  <Problem :son="24" :questions="questions" />
</template>

<script>
import Problem from '@/components/experimentation/problem .vue'
export default {
  components: { Problem },
  props: [],
  data() {
    return {
      questions: [
        {
          id: 0,
          question: 'lang.ct.two.three.ll_child.firstQ.question',
          options: [
            { value: 'A', label: 'lang.ct.two.three.ll_child.firstQ.option.A' },
            { value: 'B', label: 'lang.ct.two.three.ll_child.firstQ.option.B' },
            { value: 'C', label: 'lang.ct.two.three.ll_child.firstQ.option.C' },
            { value: 'D', label: 'lang.ct.two.three.ll_child.firstQ.option.D' },
          ],
          answer: '',
          result: 'D',
          score: 2,
          scored: 0,
        },
        {
          id: 1,
          question: 'lang.ct.two.three.ll_child.secondQ.question',
          options: [
            {
              value: 'A',
              label: 'lang.ct.two.three.ll_child.secondQ.option.A',
            },
            {
              value: 'B',
              label: 'lang.ct.two.three.ll_child.secondQ.option.B',
            },
            {
              value: 'C',
              label: 'lang.ct.two.three.ll_child.secondQ.option.C',
            },
            {
              value: 'D',
              label: 'lang.ct.two.three.ll_child.secondQ.option.D',
            },
          ],
          answer: '',
          result: 'B',
          score: 2,
          scored: 0,
        },
      ],
    }
  },
}
</script>